import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_fire_wardens_training'

export default {
  key: 'security_managment_fire_wardens_training',
  label: 'GSMS - Fire Wardens Training',
  timeColumn: 'security_managment_fire_wardens_training.fw_training_date_completed',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_fire_wardens_training: ["id", "building_code", "occupied_seat_count_per_floor", "fire_warden_soeid", "fire_warden_name", "fw_training_date_assigned", "fw_training_status", "fw_training_date_completed", "fw_training_previous_status", "fw_training_previous_date_completed", "created_at", "updated_at"],
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_fire_wardens_training',
    columns: 'security_managment_facility.building_code,security_managment_facility.facility_name,security_managment_facility.address,security_managment_facility.city,security_managment_facility.state,security_managment_facility.country,security_managment_facility.primary_facility_type,security_managment_facility.csis_building_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre instalacion' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_facility.primary_facility_type', label: 'Tipo' },
    { key: 'security_managment_facility.csis_building_status', label: 'Nivel' },
    { key: 'security_managment_fire_wardens_training.fw_training_status', label: 'Estatus' },
    { key: 'security_managment_fire_wardens_training.fire_warden_name', label: 'Guardian de incendios' },
    { key: 'security_managment_fire_wardens_training.fire_warden_soeid', label: 'Referencia' },
    { key: 'security_managment_fire_wardens_training.fw_training_date_completed', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre instalacion', 'facility_name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_fire_wardens_training.fw_training_status', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_fire_wardens_training.fire_warden_name', 'Guardian de incendios', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_fire_wardens_training.fire_warden_soeid', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_facility.primary_facility_type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_facility.csis_building_status', 'Nivel', 'level'),
  ],

    dateGrouping: {
    column: 'security_managment_fire_wardens_training.fw_training_date_completed',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
